import React from 'react';
import './SliderPlaying.scss';
import Slider from 'react-rangeslider';
import { useDataLayerValue } from '../../../DataLayer';


function SliderVolume(props) {
    const [{ volume }, dispatch] = useDataLayerValue();

    const handleChangeVolume = (value) => {
        let newVolumeValue = value;
        dispatch({
            type: 'SET_VOLUME',
            volume: newVolumeValue / 100
        });

    }
    return (

        <div className='slider-horizontal slider-horizontal-volume'>
            <Slider
                min={0}
                max={100}
                value={volume * 100}
                orientation='horizontal'
                onChange={handleChangeVolume}
            />
        </div>

    );
}

export default SliderVolume;